//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DetailBase.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-04-17                                                  </Created>
//  </FileHeader>


namespace Gordic.Adm.WebControls {

    export interface IGAdmMessageSettings {
        title: string;
        text: string;
        exception?: any, 
        icon?: string | null;
        id?: string;
    }

    /**
     * Třída DetailBase
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class DetailBase {

        /** Objekt popisující metadata políček načtených ze serveru při load_data*/
        public MetaData: Gordic.AdmIsl.Interface.GAdmSubjectMetaData | null;

        public Permissions: Gordic.AdmIsl.Interface.GAdmSubjectPermissions | null;

        /** pointer na objekt formulare */
        public DetailForm: Gordic.Forms.Form;

        /** element formu */
        public formElement: JQuery<HTMLElement> | null;


        /** příznak, že se jedná o nový záznam */
        public newRecord: boolean;
        /** Příznak, že okno se nachází v editačním režimu */
        public editMode: boolean;

        /** sxs pro toto okno */
        public sxsDetail?: string | null;
        /** typ_obj pro toto okno */
        public typObjDetail?: number | null;


        /** element sidebaru */
        public sidebar: JQuery<HTMLElement>;
        /** panel id (string) */
        public panelId: string;
        /** element panelu v sidebaru */
        public panelElement: JQuery<HTMLElement>;

        ///** testování práce s kontextem z funkcí rodice a potomka */
        //public Cislo: number;

        ///** testovací funkce pro ověření práce s pointrem na funkci s možností ji přenastavit ) */
        //public DejCislo: (content: GContentType<DetailBase>) => number;

        ///** testovací funkce pro ověření práce s pointrem na funkci s možností ji přenastavit ) */
        //public DejCisloThis: () => number;

        
        public MakeForm: (a_name: string) => Gordic.Forms.Form;
        public FinishMakeForm: () => JQuery<HTMLElement>;
        public MakeSection: (a_name: string) => Gordic.Forms.Form;
        public MakeRow: (a_name: string) => Gordic.Forms.Form;
        public MakeField: <T = any>(a_name: string, ...extendedOptions: GControlBoxOptions< T | T[]>[]) => Gordic.Forms.Form;
        public MakeFields: (a_name: string) => Gordic.Forms.Form;
        public MakeBoolField: <T = any>(a_name: string, ...extendedOptions: /* GControlBoxOptions<T | T[]>[]*/GCheckOptions[]) => Gordic.Forms.Form;
        public MakeBool10Field: (a_name: string) => Gordic.Forms.Form;
        public MakeSelectField: <T = any>(a_name: string, fieldOptions: GSelectBoxOptions<T>, ...extendedOptions: GSelectBoxOptions<T, T | T[]>[]) => Gordic.Forms.Form;
        public MakeFormField: <T = any>(a_name: string, fieldOptions: GFormBoxOptions<T>) => Gordic.Forms.Form;
        public CreateStatusBar: (data: any, priz_new: boolean) => void;

        public SetEditMode: (editMode: boolean) => boolean;
        public SetMenuButtons: (editMode: boolean) => boolean;

        public HideField: (fieldName: string) => void
        public ShowField: (fieldName: string) => void

        public ShowErrorNot: (notSettings: IGAdmMessageSettings) => void
        public ShowSucessNot: (notSettings: IGAdmMessageSettings) => void

        //public MakeStringField: (a_name: string) => Gordic.Forms.Form;
        //public MakeNumberField: (a_name: string) => Gordic.Forms.Form;

        static _hideField(that: GContentType<DetailBase>, fieldName: string) {
            var field = that.findFields(fieldName);
            if (field.length > 0)
                field.parent().parent().hide();
        }

        static _showField(that: GContentType<DetailBase>, fieldName: string) {
            var field = that.findFields(fieldName);
            if (field.length > 0)
                field.parent().parent().show();
        }

        static CloseAction(that: GContentType<DetailBase>): any {
            return $.Deferred(function () {
                var def = this;
                if (that.editMode == true) {
                    GDlg.confirm("jres:33000010").on("yes", () => { //RC 33000010 : Opravdu chcete opustit detail bez uložení?
                        def.resolve();
                    }).on("no", () => {
                        def.reject();
                    })
                } else
                    def.resolve();
            })
        }

        /**
         * DetailBaseInit
         * 
         * @param {GContentType<SeznamBase>} that
         */
        static DetailBaseInit(that: GContentType<DetailBase>) {

            // stare pokusy
            //that.Cislo = 1;
            //that.DejCislo = DetailBase.DejCisloDetailBase;                        // propojím veřejný pointer na funkci s lokální implementací této funkce
            //that.DejCisloThis = (): number => { return DetailBase.DejCisloDetailBase(that); };
            //that.DejCislo = (content: GContentType<DetailBase>): number => {
            //    return 1;
            //};

            that.MakeForm = (a_name: string): Gordic.Forms.Form => { return DetailBase._makeForm(that, a_name); };
            that.FinishMakeForm = (): JQuery<HTMLElement> => { return DetailBase._finishMakeForm(that); };
            that.MakeSection = (a_name: string): Gordic.Forms.Form => { return DetailBase._makeSection(that, a_name); };
            that.MakeRow = (a_name: string): Gordic.Forms.Form => { return DetailBase._makeRow(that, a_name); };
            that.MakeField = <T = any>(a_name: string, ...extendedOptions: GControlBoxOptions< T | T[]>[]): Gordic.Forms.Form => { return DetailBase._makeField(that, a_name, ...extendedOptions ); };
            that.MakeFields = (a_name: string): Gordic.Forms.Form => { return DetailBase._makeFields(that, a_name); };
            that.MakeBoolField = <T = any>(a_name: string, ...extendedOptions: GCheckOptions[]): Gordic.Forms.Form => { return DetailBase._makeBoolField(that, a_name, ...extendedOptions ); };
            that.MakeBool10Field = (a_name: string): Gordic.Forms.Form => { return DetailBase._makeBool10Field(that, a_name); };
            that.MakeSelectField = <T = any>(a_name: string, fieldOptions: GSelectBoxOptions<T>, ...extendedOptions: GSelectBoxOptions<T, T | T[]>[]): Gordic.Forms.Form => { return DetailBase._makeSelectField(that, a_name, fieldOptions, ...extendedOptions); };
            that.MakeFormField = <T = any>(a_name: string, fieldOptions: GFormBoxOptions<T>): Gordic.Forms.Form => { return DetailBase._makeFormField(that, a_name, fieldOptions) }
            //that.MakeStringField = (a_name: string): Gordic.Forms.Form => { return DetailBase._makeStringField(that, a_name); };
            //that.MakeNumberField = (a_name: string): Gordic.Forms.Form => { return DetailBase._makeNumberField(that, a_name); };
            that.SetEditMode = (a_editMode: boolean): boolean => { return DetailBase._setEditMode(that, a_editMode); };
            that.SetMenuButtons = (a_editMode: boolean): boolean => { return DetailBase._setMenuButtons(that, a_editMode); };
            that.HideField = (fieldName: string): void => { return DetailBase._hideField(that, fieldName); };
            that.ShowField = (fieldName: string): void => { return DetailBase._showField(that, fieldName); };
            that.ShowErrorNot = (notSettings: IGAdmMessageSettings): void => { return DetailBase._showLoadError(that, notSettings); };
            that.ShowSucessNot = (notSettings: IGAdmMessageSettings): void => { return DetailBase._showSucess(that, notSettings); };
            that.CreateStatusBar = (data: any, priz_new: boolean): void => { return DetailBase._createStatusBar(that, data, priz_new) }
        }

        /**
         * Vytvoření formuláře 
         * @param that
         * @param formName
         */
        private static _makeForm(that: GContentType<DetailBase>, formName: string ) : Gordic.Forms.Form {
            var form = new Gordic.Forms.Form({
                name: formName,
                layoutDescriptor: "L1M1S1, L-2-6-4, M-4-8-0, S-12-12-0",
                //layoutDescriptor: "L2M2S1, L-2-6-4, M-4-8-0, S-12-12-0",
            });
            that.DetailForm = form;
            return (form);
        }

        /**
         * Dokončení vytvoření formuláře 
         * @param that
         * @param formName
         */
        private static _finishMakeForm(that: GContentType<DetailBase>): JQuery<HTMLElement> {

            // pokud byl formulář již vykreslen, smaž ho!
            if (that.formElement != null) {
                that.formElement.remove();
            }
            var form = $("<div>").appendTo(that.element);
            that.formElement = form;
            form.gform("createFrom", that.DetailForm);

            Gordic.Utils.Form.markRequired(that.findForms());

            // Vytvoření funkce pro přechod na editační režim v rámci dvojkliku na libovolném políčku formuláře
            form.findFields().dblclick(() => {
                if (that.newRecord === false && Utils.getCanEdit(that.Permissions)) {
                    that.SetEditMode(true);
                    that.SetMenuButtons(true);
                }
            });

            // zneviditelnění polí
            if (that.MetaData?.detail_fields !== undefined && that.MetaData?.detail_fields !== null) {
                var v_detail_fields = that.MetaData?.detail_fields as ObjectLiteral<Gordic.AdmIsl.Interface.GAdmFieldMetaData>;
                var v_pole_jmen = Object.getOwnPropertyNames(v_detail_fields);
                v_pole_jmen.forEach(function (v_name) {
                    var v_visible = v_detail_fields[v_name].field_visible ?? true;

                    if (!v_visible) {
                        that.findFormRows("row_" + v_name).hide();
                    }
                });
            }


            return (form);
        }

        /**
         * Vytvoření řádku formuláře pro políčko zadaného jména - na základě údajů v MetaData
         * @param that
         * @param a_name
         */
        private static _makeSection(that: GContentType<DetailBase>, a_name: string): Gordic.Forms.Form {
            var v_row = that.DetailForm.addSection(a_name); 
            return v_row;
        }

        /**
         * Vytvoření řádku formuláře pro políčko zadaného jména - na základě údajů v MetaData
         * @param that
         * @param a_name
         */
        private static _makeRow(that: GContentType<DetailBase>, a_name: string): Gordic.Forms.Form {
            var v_row = that.DetailForm;
            var label: string = that.MetaData?.detail_fields?.[a_name]?.field_caption ?? "";
            if (label.trim() !== "" ) {
                v_row = that.DetailForm.addRow({
                    label: label,
                    name: "row_" + a_name
                });
            }
            return v_row;
        }

        ///**
        // * Vytvoření políčka 
        // * @param that
        // * @param a_name
        // */
        //private static _makeStringField(that: GContentType<DetailBase>, a_name: string ): Gordic.Forms.Form {
        //    var v_row = that.DetailForm;
        //    var v_fieldObj = that.MetaData?.detail_fields?.[a_name] ?? null;
        //    if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
        //    {
        //        var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
        //        var v_label: string = v_field.field_caption ?? "";                          // popisek policka

        //        var v_readonly: boolean = !that.editMode;           // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
        //        if (that.editMode)                                  // pokud je editacni rezim okna - potom pole jsou obecne pristupna
        //            v_readonly = v_field.field_readonly ?? true;    // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni

        //        // zkusim vytvorit pole validatoru
        //        var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
        //        v_validators = new Array();
        //        if (v_field.field_mandatory ?? false) {
        //            v_validators.push(new Gordic.Validators.Required());
        //        }

        //        v_row = that.DetailForm.addRow({
        //            label: v_label
        //        });

        //        v_row = that.DetailForm.addField("gstringbox", {
        //            name: a_name,
        //            disabled: v_readonly,
        //            validators: v_validators
        //        });
        //    }
        //    return v_row;
        //}

        ///**
        // * Vytvoření políčka 
        // * @param that
        // * @param a_name
        // */
        //private static _makeNumberField(that: GContentType<DetailBase>, a_name: string): Gordic.Forms.Form {
        //    var v_row = that.DetailForm;
        //    var v_fieldObj = that.MetaData?.detail_fields?.[a_name] ?? null;
        //    if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
        //    {
        //        var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
        //        var v_label: string = v_field.field_caption ?? "";                          // popisek policka

        //        var v_readonly: boolean = !that.editMode;           // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
        //        if (that.editMode)                                  // pokud je editacni rezim okna - potom pole jsou obecne pristupna
        //            v_readonly = v_field.field_readonly ?? true;    // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni

        //        // zkusim vytvorit pole validatoru
        //        var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
        //        v_validators = new Array();
        //        if (v_field.field_mandatory ?? false) {
        //            v_validators.push(new Gordic.Validators.Required());
        //        }

        //        v_row = that.DetailForm.addRow({
        //            label: v_label
        //        });

        //        v_row = that.DetailForm.addField("gnumberbox", {
        //            name: a_name,
        //            disabled: v_readonly,
        //            validators: v_validators
        //        });
        //    }
        //    return v_row;
        //}

        /**
         * Vytvoření políček
         * @param that
         * @param a_name
         */
        private static _makeFields(that: GContentType<DetailBase>, a_name: string): Gordic.Forms.Form {
            var v_row = that.DetailForm;
            var nameArray = a_name.split(',');
            nameArray.forEach(function (name) {
                v_row = DetailBase._makeField(that, name);
            });
            return v_row;
        }

        /**
         * Vytvoření políčka pro boolean - zatržítko kde ale true je 10
         * @param that
         * @param a_name
         */
        private static _makeBool10Field(that: GContentType<DetailBase>, a_name: string): Gordic.Forms.Form {
            var v_row = that.DetailForm;
            var v_fieldObj = that.MetaData?.detail_fields?.[a_name] ?? null;
            if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
            {
                var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
                var v_label: string = v_field.field_caption ?? "";                          // popisek policka

                var v_readonly: boolean = !that.editMode;           // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
                if (that.editMode)                                  // pokud je editacni rezim okna - potom pole jsou obecne pristupna
                    v_readonly = v_field.field_readonly ?? true;    // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni

                // pro zatržítka je mandatory nesmysl a akorát to dělá problémy
                // zkusim vytvorit pole validatoru
                var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
                v_validators = new Array(); // takže to naschvál nechám prázdné
                //if (v_field.field_mandatory ?? false) {
                //    v_validators.push(new Gordic.Validators.Required());
                //}

                v_row = that.DetailForm.addRow({
                    label: v_label,
                    name: "row_" + a_name
                });

                v_row = that.DetailForm.addField("gcheck", {
                    name: a_name,
                    disabled: v_readonly,
                    validators: v_validators,
                    modelValueTransform: {
                        apply: function (modelValue) { return modelValue === 10; },
                        collect: function (fieldValue) { return fieldValue === true ? 10 : 0; }
                    }
                });
            }
            return v_row;
        }

        /**
         * Vytvoření políčka pro boolean - zatržítko
         * @param that
         * @param a_name
         */
        private static _makeBoolField<T = any>(that: GContentType<DetailBase>, a_name: string, ...extendedOptions: GCheckOptions[]): Gordic.Forms.Form {
            var v_row = that.DetailForm;
            var v_fieldObj = that.MetaData?.detail_fields?.[a_name] ?? null;
            if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
            {
                var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
                var v_label: string = v_field.field_caption ?? "";                          // popisek policka

                var v_readonly: boolean = !that.editMode;           // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
                if (that.editMode)                                  // pokud je editacni rezim okna - potom pole jsou obecne pristupna
                    v_readonly = v_field.field_readonly ?? true;    // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni

                // pro zatržítka je mandatory nesmysl a akorát to dělá problémy
                // zkusim vytvorit pole validatoru
                var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
                v_validators = new Array(); // takže to naschvál nechám prázdné
                //if (v_field.field_mandatory ?? false) {
                //    v_validators.push(new Gordic.Validators.Required());
                //}

                v_row = that.DetailForm.addRow({
                    label: v_label,
                    name: "row_" + a_name
                });

                var fieldOptions: GCheckOptions = {
                    name: a_name,
                    disabled: v_readonly,
                    validators: v_validators,
                    modelValueTransform: {
                        apply: function (modelValue) { return modelValue === 1; },
                        collect: function (fieldValue) { return fieldValue === true ? 1 : 0; }
                    }
                };

                var fieldOptionsfinal: GCheckOptions = fieldOptions;
                if (Array.isArray(extendedOptions)) {
                    var pole = extendedOptions as GCheckOptions[];
                    pole.forEach(function (option) {
                        fieldOptionsfinal = { ...fieldOptionsfinal, ...option };
                    });
                } else {
                    var one = extendedOptions as GCheckOptions;
                    fieldOptionsfinal = { ...fieldOptionsfinal, ...one };
                }

                v_row = that.DetailForm.addField("gcheck", fieldOptionsfinal );
            }
            return v_row;
        }

        /**
         * Vytvoření políčka - typ je určen obsahem: MetaData
         * @param that
         * @param a_name
         */
        private static _makeField<T = any>(that: GContentType<DetailBase>, a_name: string, ...extendedOptions: GControlBoxOptions< T | T[]>[]): Gordic.Forms.Form {
            var v_row = that.DetailForm;
            var v_fieldObj = that.MetaData?.detail_fields?.[a_name] ?? null;
            if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
            {

                var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
                var v_field_base_type = v_field.field_base_type || "OTHER";     // as Gordic.General.GFieldBaseTypeEnum;
                var v_label: string = v_field.field_caption ?? "";              // popisek policka
                var v_tooltip = v_field.field_tooltip ?? undefined;
                var v_readonly: boolean = !that.editMode;                       // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
                var v_is_pk: boolean = v_field.field_is_pk ?? false;            // zjistim, zda je soucast PK
                if (that.editMode)                                              // pokud je editacni rezim okna - potom pole jsou obecne pristupna
                {
                    v_readonly = v_field.field_readonly ?? true;                // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni
                    if (!that.newRecord && v_is_pk)
                        v_readonly = true;
                }

                // zkusim vytvorit pole validatoru
                var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
                v_validators = new Array();
                if (v_field.field_mandatory ?? false) {
                    v_validators.push(new Gordic.Validators.Required());
                }

                //new Gordic.Validators.Length({ min: minValue, max: maxValue }

                v_row = that.DetailForm.addRow({
                    label: v_label,
                    name: "row_" + a_name
                });

                switch (v_field_base_type) {
                    case "TEXT":
                        if (v_field.field_size !== undefined && v_field !== null)
                            v_validators.push(new Gordic.Validators.Length({ params: { min: 0, max: v_field.field_size } }));

                        var fieldOptions: GStringBoxOptions = {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            emptyValue: "",
                            tooltip: v_tooltip
                        };

                        var fieldOptionsfinal: GStringBoxOptions = fieldOptions;
                        if (Array.isArray(extendedOptions)) {
                            var pole = extendedOptions as GStringBoxOptions[];
                            pole.forEach(function (option) {
                                fieldOptionsfinal = { ...fieldOptionsfinal, ...option };
                            });
                        } else {
                            var one = extendedOptions as GStringBoxOptions;
                            fieldOptionsfinal = { ...fieldOptionsfinal, ...one };
                        }

                        v_row = that.DetailForm.addField("gstringbox", fieldOptionsfinal );
                        break;

                    case "DATETIME":
                        v_row = that.DetailForm.addField("gdatebox", {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            valueType: "datetime",
                            tooltip: v_tooltip
                        });
                        break;
                    case "DATE":
                        v_row = that.DetailForm.addField("gdatebox", {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            valueType: "date",
                            tooltip: v_tooltip
                        });
                        break;
                    case "NUMBER":
                    case 1:

                        var numFieldOptions: GNumberBoxOptions = {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            tooltip: v_tooltip
                        };

                        var numFieldOptionsfinal: GNumberBoxOptions = numFieldOptions;
                        if (Array.isArray(extendedOptions)) {
                            var numPole = extendedOptions as GNumberBoxOptions[];
                            numPole.forEach(function (option) {
                                numFieldOptionsfinal = { ...numFieldOptionsfinal, ...option };
                            });
                        } else {
                            var numOne = extendedOptions as GNumberBoxOptions;
                            numFieldOptionsfinal = { ...numFieldOptionsfinal, ...numOne };
                        }

                        v_row = that.DetailForm.addField("gnumberbox", numFieldOptionsfinal );
                        break;

                    case "DECIMAL":
                        v_row = that.DetailForm.addField("gstringbox", {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            tooltip: v_tooltip
                        });
                        break;

                    case "BOOLEAN":
                        v_row = that.DetailForm.addField("gcheck", {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            tooltip: v_tooltip
                        });
                        break;
                }
            }
            return v_row;
        }
        
        /**
         * Vytvoření políčka 
         * @param that
         * @param a_name
         */
        private static _makeSelectField<T = any>(that: GContentType<DetailBase>, a_name: string, fieldOptions: GSelectBoxOptions<T>, ...extendedOptions: GSelectBoxOptions<T, T | T[]>[] ): Gordic.Forms.Form {
            var v_row = that.DetailForm;
            var v_fieldObj = that.MetaData?.detail_fields?.[a_name] ?? null;
            if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
            {
                var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
                var v_label: string = v_field.field_caption ?? "";                          // popisek policka

                var v_readonly: boolean = !that.editMode;           // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
                if (that.editMode)                                  // pokud je editacni rezim okna - potom pole jsou obecne pristupna
                    v_readonly = v_field.field_readonly ?? true;    // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni

                // zkusim vytvorit pole validatoru
                var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
                v_validators = new Array();
                if (v_field.field_mandatory ?? false) {
                    v_validators.push(new Gordic.Validators.Required());
                }

                fieldOptions.name = a_name;
                fieldOptions.disabled = v_readonly;
                fieldOptions.validators = v_validators;
                fieldOptions.dropdown = true;
                fieldOptions.model = a_name + " = " + a_name;

                var fieldOptionsfinal: GSelectBoxOptions<T> = fieldOptions;

                if (Array.isArray(extendedOptions)) {
                    var pole = extendedOptions as GSelectBoxOptions<T>[];
                    pole.forEach(function (option) {
                        fieldOptionsfinal = { ...fieldOptionsfinal, ...option };
                    });
                } else {
                    var one = extendedOptions as GSelectBoxOptions<T>;
                    fieldOptionsfinal = { ...fieldOptionsfinal, ...one };
                }

                //var fieldOptionsfinal: GSelectBoxOptions<T> = { ...fieldOptions, ...extendedOptions };

                v_row = that.DetailForm.addRow({
                    label: v_label,
                    name: "row_" + a_name
                });

                v_row = that.DetailForm.addField("gselectbox", fieldOptionsfinal );
            }
            return v_row;
        }

        private static _makeFormField<T = any>(that: GContentType<DetailBase>, a_name: string, fieldOptions: GFormBoxOptions<T>) {
            var v_row = that.DetailForm;
            var v_fieldObj = that.MetaData?.detail_fields?.[a_name] ?? null;
            if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
            {
                var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
                var v_label: string = v_field.field_caption ?? "";                          // popisek policka

                var v_readonly: boolean = !that.editMode;           // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
                if (that.editMode)                                  // pokud je editacni rezim okna - potom pole jsou obecne pristupna
                    v_readonly = v_field.field_readonly ?? true;    // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni

                // zkusim vytvorit pole validatoru
                var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
                v_validators = new Array();
                if (v_field.field_mandatory ?? false) {
                    v_validators.push(new Gordic.Validators.Required());
                }

                fieldOptions.name = a_name;
                fieldOptions.disabled = v_readonly;
                fieldOptions.validators = v_validators;
                fieldOptions.model = a_name + " = " + a_name;

                var fieldOptionsfinal: GSelectBoxOptions<T> = fieldOptions;

                v_row = that.DetailForm.addRow({
                    label: v_label,
                    name: "row_" + a_name
                });

                v_row = that.DetailForm.addField("gformbox", fieldOptionsfinal);
            }
            return v_row;
        }


        /** Přepnutí dostupnosti políček podle aktuálního režimu okna 
         editMode - příznak, že okno je v editačním režimu
         */
        private static _setEditMode(that: GContentType<DetailBase>,editMode: boolean) {
            // odblokování/zablokování všech políček formuláře podle metadat a aktuálního režimu okna
            if (!editMode) {
                that.findFields().gfield("option", { disabled: true });
            }
            else {
                if (that.MetaData?.detail_fields !== undefined && that.MetaData?.detail_fields !== null) {
                    var v_detail_fields = that.MetaData?.detail_fields as ObjectLiteral<Gordic.AdmIsl.Interface.GAdmFieldMetaData>;
                    var v_pole_jmen = Object.getOwnPropertyNames(v_detail_fields);
                    v_pole_jmen.forEach(function (v_name) {
                        var v_readonly = v_detail_fields[v_name].field_readonly ?? true;
                        var v_is_pk = v_detail_fields[v_name].field_is_pk ?? false;
                        if (!that.newRecord && v_is_pk) {
                            that.findFields(v_name).gfield("option", 'disabled', true);
                        }
                        else {
                            that.findFields(v_name).gfield("option", { disabled: v_readonly });
                        }
                    });
                }
            }
            if (editMode == true)
                $(".adm-sub-panels").remove();

            //if (!this.newRecord)    // nasledující políčka jsou přístupná pouze při zakládání záznamu
            //{
            //    this.findFields("ixs_orj").gfield("option", { disabled: true });
            //}

            that.editMode = editMode;
            return (editMode);
        }
        
        /** Přepnutí viditelnost tlačítek podle aktuálního režimu okna 
         editMode - příznak, že okno je v editačním režimu
         */
        private static _setMenuButtons(that: GContentType<DetailBase>, editMode: boolean) {
            Utils.setActionVisible(that.actions.actEditRecord, !editMode);
            if (that.newRecord == true) {
                // Nový záznam kontrola jestli můžu přidávat
                var canAdd = Utils.getCanAdd(that.Permissions);
                Utils.setActionEnabled(that.actions.actSaveRecord, canAdd);
                if (canAdd !== true)
                    Utils.setActionTooltip(that.actions.actSaveRecord, that.Permissions?.CreateReason);
                else
                    Utils.setActionTooltip(that.actions.actSaveRecord, "");
            } else {
                // Stávající záznam kontrola jestli můžu editovat
                var canEdit: boolean = Utils.getCanEdit(that.Permissions);
                Utils.setActionEnabled(that.actions.actEditRecord, canEdit);
                Utils.setActionEnabled(that.actions.actSaveRecord, canEdit);
                if (canEdit !== true) {
                    Utils.setActionTooltip(that.actions.actSaveRecord, that.Permissions?.WriteReason);
                    Utils.setActionTooltip(that.actions.actEditRecord, that.Permissions?.WriteReason);
                } else {
                    Utils.setActionTooltip(that.actions.actEditRecord, "");
                    Utils.setActionTooltip(that.actions.actSaveRecord, "");
                }
            }
            Utils.setActionVisible(that.actions.actSaveRecord, editMode);
            Utils.setActionVisible(that.actions.actCancelSaveRecord, editMode);
            Utils.setActionVisible(that.actions.actRefresh, !editMode);
            return (editMode);
        }

        /** odstranit sidebar */
        public static removeSidebar(that: GContentType<DetailBase>) {
            if (that.sidebar !== undefined) {
                that.sidebar.gsidebar("removeAll");
            }
        }

        ///**
        // * Impelemntace funkce DejCislo pro tuto úroveň
        // * @param content
        // */
        //public static DejCisloDetailBase = (content: GContentType<DetailBase>) : number =>
        //{
        //    return content.Cislo + 1;
        //};

        ///**
        // * Impelemntace funkce DejCislo pro tuto úroveň
        // * @param content
        // */
        //public static DejCisloDetailBase(content: GContentType<DetailBase>): number
        //{
        //    return content.Cislo + 1;
        //};

        /**
         * Smazání všech cache - volá se po úspěšném uložení záznamu do DB
         * @param content
         */
        public static ClearAllCache(content: GContentType<DetailBase>) {
            Gordic.Adm.Utils.clearAllCache();
        };

        public static _showLoadError(content: GContentType<DetailBase>, settings: IGAdmMessageSettings) {
            content.notification("add", {
                title: settings.title,
                content: "jres:32000124: {0}".format(settings.text),
                icon: (settings.icon) ? settings.icon : "fa-times-circle",
                state: "error"
            })
        }

        public static _showSucess(content: GContentType<DetailBase>, settings: IGAdmMessageSettings) {
            content.notification("showToast", {
                title: settings.title,
                content: settings.text,
                icon: (settings.icon) ? settings.icon : "fa-check-circle",
                state: "success"
            })
        }

        public static _createStatusBar(content: GContentType<DetailBase>, data: any, priz_new: boolean) {
            var text = "";
            var color = "";
            if (priz_new == false) {
                if (data.aktivita) {
                    switch (data.aktivita) {
                        case 100:
                            text = "jres:33000139";
                            color = "g-state-success"
                            break;
                        case 300:
                            text = "jres:33000142"; //RC 33000142 : Připraven
                            color = "g-state-info";
                            break;
                        case 500:
                            text = "jres:33000140";
                            color = "g-state-warning";
                            break;
                        case 600:
                            text = "jres:33000141" //RC 33000141 : Návrh
                            color = "g-state-info";
                            break;
                        default:
                            text = "jres:33000143" //RC 33000143 : Zrušen
                            color = "g-state-error"
                            break;
                    }
                }
            } else {
                text = "jres:32000121";
                color = "g-state-info";
            }
            if (text != "") {
                content.statusBar([
                    {
                        type: "static",
                        caption: "jres:33000144" //RC 33000144 : Záznam je ve stavu:
                    },
                    {
                        type: "static",
                        //caption: text.toUpperCase(),
                        //customClass: "g-state-text " + color
                        badge: {
                            value: text,
                            customClass: color
                        }
                    }
                ])
            }
        }
    }
}
